import React from 'react';
import {
  OperationProgressWindowRequest,
  type OperationProgressModel,
} from '../../../shared/ui/progress';

interface WorkflowAvailabilityProgressProps {
  model: OperationProgressModel | null;
  suppressed?: boolean;
  visible: boolean;
}

const getAvailabilityProgressIdentity = (model: OperationProgressModel): string =>
  model.operationId ?? `${model.title}:${model.message}`;

const WorkflowAvailabilityProgress: React.FC<WorkflowAvailabilityProgressProps> = ({
  model,
  suppressed = false,
  visible,
}) => {
  const [suppressedProgressIdentity, setSuppressedProgressIdentity] = React.useState<string | null>(null);
  const progressIdentity = model ? getAvailabilityProgressIdentity(model) : null;
  const hideSuppressedCheck =
    Boolean(progressIdentity) &&
    Boolean(suppressedProgressIdentity) &&
    suppressedProgressIdentity === progressIdentity;

  React.useEffect(() => {
    if (!visible || !progressIdentity) {
      setSuppressedProgressIdentity(null);
      return;
    }

    if (suppressed) {
      setSuppressedProgressIdentity(progressIdentity);
      return;
    }

    if (suppressedProgressIdentity && suppressedProgressIdentity !== progressIdentity) {
      setSuppressedProgressIdentity(null);
    }
  }, [progressIdentity, suppressed, suppressedProgressIdentity, visible]);

  if (!visible || !model || suppressed || hideSuppressedCheck) {
    return null;
  }

  return (
    <OperationProgressWindowRequest
      id="workflow-setup-availability-progress"
      open
      model={model}
      priority={10}
    />
  );
};

export default WorkflowAvailabilityProgress;
